var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',{staticClass:"ml-2 mr-3",attrs:{"color":"primary","loading":_vm.testing},on:{"click":function($event){return _vm.testEmail(_vm.email)}}},[_vm._v("Test")])}
var staticRenderFns = []

export { render, staticRenderFns }